import { combineReducers } from 'redux';
import usersReducer from './modules/users/reducer';
import usageReducer from './modules/usage/reducer';
import organizationReducer from './modules/organization/reducer';
import appReducer from './modules/app/reducer';
import billingReducer from './modules/billing/reducer';
import profileReducer from './modules/profile/reducer';
import vettingReducer from './modules/vetting/reducer';
import signUpReducer from './modules/signup/reducer';

export const rootReducer = combineReducers({
  users: usersReducer.reducer,
  usage: usageReducer.reducer,
  organization: organizationReducer.reducer,
  profile: profileReducer.reducer,
  app: appReducer.reducer,
  billing: billingReducer.reducer,
  vetting: vettingReducer.reducer,
  signup: signUpReducer.reducer,
});

export default rootReducer;
